import { useState } from "react";
import { useDisclosure } from "@mantine/hooks";
import { Button } from "@mantine/core";
import OrderItemDetailsModal from "../OrderItemDetailsModal/OrderItemDetailsModal";
import dayjs from "dayjs";
import clsx from "clsx";
import "./Steps.css";
import { Order } from "@/api/types";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Receipt from "../../Shared/Receipt/Receipt";

interface HistoryProps {
  orders?: Order[];
}

const History: React.FC<HistoryProps> = ({ orders }) => {
  const [opened, { open, close }] = useDisclosure(false);
  const [detailsItem, setDetailsItem] = useState<Order>();
  const [visibleCount, setVisibleCount] = useState(3);
  const openOrderDetails = (item: Order) => {
    setDetailsItem(item);
    open();
  };
  return (
    <div className="payment-history-container">
      <div className="payment-history-title">Povijest kupovine</div>
      <div className="payment-history-items">
        {orders && orders?.length ? (
          <div className="flex flex-col border border-[#eaeaea] rounded-lg">
            {orders?.slice(0, visibleCount).map((order, index) => (
              <div
                key={order.id}
                className={clsx(
                  "flex-col p-4 justify-start inline-flex",
                  index !== orders.length - 1 && "border-b border-[#eaeaea]"
                )}
              >
                <div className="flex w-full justify-between items-center">
                  <div className="flex flex-col w-full gap-2">
                    <div className="flex justify-between item-start">
                      <div className="flex flex-col gap-2">
                        {order.orderItems.map((item) => (
                          <div
                            key={item.id}
                            className="self-stretch text-[#0b1a29] text-sm font-medium"
                          >
                            {item.subscription
                              ? item.subscription.title
                              : item.issue
                              ? item.issue?.title
                              : item.publication?.title}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="text-[#515151] text-[0.825rem] font-medium">
                      Kupljeno: {dayjs(order.createdAt).format("DD.MM.YYYY.")}
                    </div>
                    <PDFDownloadLink
                      document={<Receipt order={order} />}
                      fileName={`${order.guid}.pdf`}
                      className="w-fit"
                    >
                      {({ loading }) => (
                        <div
                          className={clsx(
                            "text-[#004a99] text-sm font-medium underline",
                            loading && "pointer-events-none"
                          )}
                        >
                          Preuzmi račun
                        </div>
                      )}
                    </PDFDownloadLink>
                  </div>
                  <div className="text-[#515151] text-sm font-medium">
                    {order.price}€
                  </div>
                </div>
              </div>
            ))}

            {visibleCount < orders?.length && (
              <div className="p-3 flex justify-center">
                <Button
                  variant="transparent"
                  color="#004a99"
                  className="!text-sm !font-bold"
                  onClick={() => setVisibleCount(visibleCount + 3)}
                >
                  Prikaži više
                </Button>
              </div>
            )}
            {visibleCount > 3 && (
              <div className="p-3 border-t flex justify-center">
                <Button
                  variant="transparent"
                  color="#004a99"
                  className="!text-sm !font-bold"
                  onClick={() => setVisibleCount(3)}
                >
                  Prikaži manje
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className="flex justify-start items-start text-[#515151] text-sm font-medium">
            Trenutno nema kupnji
          </div>
        )}
      </div>
      <div className="payment-history-items-mobile">
        {orders?.length ? (
          orders.map((order) => (
            <div
              key={order.id}
              className="flex justify-between items-center p-4 border-b border-[#eaeaea]"
              onClick={() => openOrderDetails(order)}
            >
              <div className="flex-col justify-start items-start gap-2 inline-flex">
                {order.orderItems.map((orderItem) => (
                  <div
                    key={orderItem.id}
                    className="self-stretch text-[#0b1a29] text-sm font-medium"
                  >
                    {orderItem.subscription
                      ? orderItem.subscription.title
                      : orderItem.issue
                      ? orderItem.issue?.title
                      : orderItem.publication?.title}
                  </div>
                ))}
                <div className="text-[#515151] text-xs font-medium">
                  Kupljeno: {dayjs(order.createdAt).format("DD.MM.YYYY.")}
                </div>
                <div className="text-[#515151] text-xs font-medium">
                  {order.price}€
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="flex p-4 justify-between items-center text-[#515151] text-sm font-medium">
            Trenutno nema kupnji
          </div>
        )}
      </div>
      {detailsItem && (
        <OrderItemDetailsModal
          opened={opened}
          onClose={close}
          order={detailsItem}
        />
      )}
    </div>
  );
};

export default History;
